export const SERVICE_URL = process.env.SERVICE_URL;
export const ENABLE_TRACKING = process.env.ENABLE_TRACKING;
export const BLOB_URL = process.env.BLOB_URL;
export const AUTHORIZE_CLIENT_KEY = process.env.AUTHORIZE_CLIENT_KEY;
export const AUTHORIZE_API_LOGIN_ID = process.env.AUTHORIZE_API_LOGIN_ID;
export const AUTHORIZE_SCRIPT = process.env.AUTHORIZE_SCRIPT;
export const AUTH0_REDIRECT = process.env.AUTH0_REDIRECT;
export const AUTH0_DOMAIN = process.env.AUTH0_DOMAIN;
export const AUTH0_AUDIENCE = process.env.AUTH0_AUDIENCE;
export const AUTH0_CLIENTID = process.env.AUTH0_CLIENTID;
export const AUTH0_SCOPE =
  "openid profile manage:images manage:addresses manage:orders";

export const STORAGE_CART = "TB_CART";
export const STORAGE_SUPPORT_PERCENTAGE = "TB_SUPPORT_PERCENTAGE";
export const STORAGE_SUPPORT_TOTAL = "TB_SUPPORT_TOTAL";
export const STORAGE_BILLING = "TB_BILLING";
export const STORAGE_OPT_IN = "TB_OPT_IN";
export const STORAGE_BUSINESS_USE = "TB_BUSINESS_USE";
export const STORAGE_RECEIPT = "TB_STORAGE_RECEIPT";
export const STORAGE_QUOTE_ID = "TB_QUOTE_ID";
export const STORAGE_COUPON_CODE = "TB_COUPON_CODE";

export const ACTION_ADD_ALERT = "ACTION_ADD_ALERT";
export const ACTION_DISMISS_ALERT = "ACTION_DISMISS_ALERT";
export const ACTION_SET_BUSY = "ACTION_SET_BUSY";
export const ACTION_SET_CART = "ACTION_SET_CART";
export const ACTION_INITIALIZE_PROFILE = "ACTION_INITIALIZE_PROFILE";
export const ACTION_SET_SUPPORT_PERCENT = "ACTION_SET_SUPPORT_PERCENT";
export const ACTION_SET_SUPPORT_TOTAL = "ACTION_SET_SUPPORT_TOTAL";
export const ACTION_SET_BILLING = "ACTION_SET_BILLING";
export const ACTION_SET_OPT_IN = "ACTION_SET_OPT_IN";
export const ACTION_SET_BUSINESS_USE = "ACTION_SET_BUSINESS_USE";
export const ACTION_INITIALIZE_SHIPPING_METHODS =
  "ACTION_INITIALIZE_SHIPPING_METHODS";
export const ACTION_COMPLETE_PURCHASE = "ACTION_COMPLETE_PURCHASE";
export const ACTION_SET_QUOTE_DETAILS = "ACTION_SET_QUOTE_DETAILS";

export const ALERT_TYPE_ERROR = "Error";
export const ALERT_TYPE_SUCCESS = "Success";

export const VALIDATION_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const VALIDATION_ZIP = /^\d{5}$|^\d{5}-\d{4}$/;
export const VALIDATION_CREDIT_CARD =
  /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|(3(?:088|096|112|158|337|5(?:2[89]|[3-8][0-9]))\d{12}))$/;

export const MIN_CARD_VALUE = 10;
export const MAX_CARD_VALUE = 5000;
export const PLASTIC_TYPE_THEM = "Them";
export const PLASTIC_TYPE_ME = "Me";
export const PLASTIC_TYPE_NO_CARRIER = "No Carrier";
export const EMAIL_TYPE_NOW = "Now";
export const EMAIL_TYPE_LATER = "Later";
export const CARD_TYPE_PLASTIC = "Plastic";
export const CARD_TYPE_EMAIL = "Email";
export const CARD_TYPE_PRINTER = "Printer";
export const STATES = [
  { abbreviation: "AL", name: "Alabama" },
  { abbreviation: "AK", name: "Alaska" },
  { abbreviation: "AZ", name: "Arizona" },
  { abbreviation: "AR", name: "Arkansas" },
  { abbreviation: "CA", name: "California" },
  { abbreviation: "CO", name: "Colorado" },
  { abbreviation: "CT", name: "Connecticut" },
  { abbreviation: "DE", name: "Delaware" },
  { abbreviation: "DC", name: "District of Columbia" },
  { abbreviation: "FL", name: "Florida" },
  { abbreviation: "GA", name: "Georgia" },
  { abbreviation: "HI", name: "Hawaii" },
  { abbreviation: "ID", name: "Idaho" },
  { abbreviation: "IL", name: "Illinois" },
  { abbreviation: "IN", name: "Indiana" },
  { abbreviation: "IA", name: "Iowa" },
  { abbreviation: "KS", name: "Kansas" },
  { abbreviation: "KY", name: "Kentucky" },
  { abbreviation: "LA", name: "Louisiana" },
  { abbreviation: "ME", name: "Maine" },
  { abbreviation: "MD", name: "Maryland" },
  { abbreviation: "MA", name: "Massachusetts" },
  { abbreviation: "MI", name: "Michigan" },
  { abbreviation: "MN", name: "Minnesota" },
  { abbreviation: "MS", name: "Mississippi" },
  { abbreviation: "MO", name: "Missouri" },
  { abbreviation: "MT", name: "Montana" },
  { abbreviation: "NE", name: "Nebraska" },
  { abbreviation: "NV", name: "Nevada" },
  { abbreviation: "NH", name: "New Hampshire" },
  { abbreviation: "NJ", name: "New Jersey" },
  { abbreviation: "NM", name: "New Mexico" },
  { abbreviation: "NY", name: "New York" },
  { abbreviation: "NC", name: "North Carolina" },
  { abbreviation: "ND", name: "North Dakota" },
  { abbreviation: "OH", name: "Ohio" },
  { abbreviation: "OK", name: "Oklahoma" },
  { abbreviation: "OR", name: "Oregon" },
  { abbreviation: "PA", name: "Pennsylvania" },
  { abbreviation: "RI", name: "Rhode Island" },
  { abbreviation: "SC", name: "South Carolina" },
  { abbreviation: "SD", name: "South Dakota" },
  { abbreviation: "TN", name: "Tennessee" },
  { abbreviation: "TX", name: "Texas" },
  { abbreviation: "UT", name: "Utah" },
  { abbreviation: "VT", name: "Vermont" },
  { abbreviation: "VA", name: "Virginia" },
  { abbreviation: "WA", name: "Washington" },
  { abbreviation: "WV", name: "West Virginia" },
  { abbreviation: "WI", name: "Wisconsin" },
  { abbreviation: "WY", name: "Wyoming" },
];
export const SHIPPING_METHODS = [
  { id: "USPS-FClass", title: "USPS First Class - Free Shipping", rate: 0 },
  { id: "USPS-Priority", title: "USPS Priority 2-3 Day", rate: 6 },
  {
    id: "USPS-Priority-Express",
    title: "USPS Priority Express 1-2 Day",
    rate: 28,
  },
];

export const DEFAULT_SUPPORT_PERCENTAGE = 10;
export const DEFAULT_SUPPORT_TOTAL = 0;
export const DEFAULT_CARD_VALUE = 40;
export const DEFAULT_CARD_TYPE = CARD_TYPE_EMAIL;
export const DEFAULT_MAIL_OPTION = PLASTIC_TYPE_ME;
export const DEFAULT_EMAIL_OPTION = EMAIL_TYPE_LATER;
export const DEFAULT_BILLING_STATE = "";
export const DEFAULT_SHIPPING_METHOD = SHIPPING_METHODS[0];

export const ERROR_INPUT_TO = "ERROR_INPUT_TO";
export const ERROR_INPUT_FROM = "ERROR_INPUT_FROM";
export const ERROR_INPUT_EMAIL = "ERROR_INPUT_EMAIL";
export const ERROR_INPUT_DELIVERY_DATE = "ERROR_INPUT_DELIVERY_DATE";
export const ERROR_INPUT_MESSAGE = "ERROR_INPUT_MESSAGE";
export const ERROR_INPUT_SHIPPING_NAME = "ERROR_INPUT_SHIPPING_NAME";
export const ERROR_INPUT_SHIPPING_COMPANY = "ERROR_INPUT_SHIPPING_COMPANY";
export const ERROR_INPUT_SHIPPING_ADDRESS = "ERROR_INPUT_SHIPPING_ADDRESS";
export const ERROR_INPUT_SHIPPING_CITY = "ERROR_INPUT_SHIPPING_CITY";
export const ERROR_INPUT_SHIPPING_STATE = "ERROR_INPUT_SHIPPING_STATE";
export const ERROR_INPUT_SHIPPING_ZIP = "ERROR_INPUT_SHIPPING_ZIP";
export const ERROR_INPUT_SHIPPING_METHOD = "ERROR_INPUT_SHIPPING_METHOD";
export const ERROR_INPUT_BILLING_EMAIL = "ERROR_INPUT_BILLING_EMAIL";
export const ERROR_INPUT_BILLING_FIRST_NAME = "ERROR_INPUT_BILLING_FIRST_NAME";
export const ERROR_INPUT_BILLING_LAST_NAME = "ERROR_INPUT_BILLING_LAST_NAME";
export const ERROR_INPUT_BILLING_COMPANY = "ERROR_INPUT_BILLING_COMPANY";
export const ERROR_INPUT_BILLING_ADDRESS = "ERROR_INPUT_BILLING_ADDRESS";
export const ERROR_INPUT_BILLING_CITY = "ERROR_INPUT_BILLING_CITY";
export const ERROR_INPUT_BILLING_STATE = "ERROR_INPUT_BILLING_STATE";
export const ERROR_INPUT_BILLING_ZIP = "ERROR_INPUT_BILLING_ZIP";
export const ERROR_INPUT_BILLING_CARD_NUMBER =
  "ERROR_INPUT_BILLING_CARD_NUMBER";
export const ERROR_INPUT_BILLING_CARD_CODE = "ERROR_INPUT_BILLING_CARD_CODE";
export const ERROR_INPUT_BILLING_EXPIRATION = "ERROR_INPUT_BILLING_EXPIRATION";
